import {
  BATCH_UPLOAD_EDIT_LOAD_BATCH,
  BATCH_UPLOAD_EDIT_UPDATE_ROW,
  BATCH_UPLOAD_EDIT_TOGGLE_SKIP_ROW,
  BATCH_UPLOAD_EDIT_SET_LOADING,
  BATCH_UPLOAD_EDIT_SET_LOADING_PROGRESS
} from '@constants/action-types';
import initialState from '../store/initial-state';

const batchEditReducer = (state = initialState.batchEdit, action) => {
  switch (action.type) {
  case BATCH_UPLOAD_EDIT_LOAD_BATCH: {
    const { fileId, rows, fileName, entityType } = action.payload;
    const rowMap = rows.reduce((acc, row) => ({
      ...acc,
      [row.id]: {
        id: row.id,
        data: row.data,
        display_row_nums: row.display_row_nums,
        errors: row.errors || {},
        skipped: false,
        version: 0  // Initial version for comparison.
      }
    }), {});
    return {
      ...state,
      [fileId]: { rows: rowMap, fileName, entityType }
    };
  }
  case BATCH_UPLOAD_EDIT_UPDATE_ROW: {
    const { fileId, rowId, updates, errors, segmentErrors } = action.payload;
    const existingBatch = state[fileId];
    if (!existingBatch) {
      return state;  // No-op if batch not loaded
    }
    const existingRow = existingBatch.rows[rowId];
    if (!existingRow) {
      return state;  // No-op if row not found
    }

    // Start with errors from payload or existing errors
    let finalErrors = errors || existingRow.errors;

    // If segmentErrors exists and has items, append them
    if (segmentErrors && segmentErrors.length > 0) {
      finalErrors = {
        ...finalErrors,
        segments: [...(finalErrors.segments || []), ...segmentErrors]
      };
    }

    return {
      ...state,
      [fileId]: {
        ...existingBatch,
        rows: {
          ...existingBatch.rows,
          [rowId]: {
            ...existingRow,
            data: { ...existingRow.data, ...updates },
            errors: finalErrors,
            version: existingRow.version + 1
          }
        }
      }
    };
  }
  case BATCH_UPLOAD_EDIT_TOGGLE_SKIP_ROW: {
    const { fileId, rowId } = action.payload;
    const existingBatch = state[fileId];
    if (!existingBatch) {
      return state; // No-op if batch not loaded
    }
    const existingRow = existingBatch.rows[rowId];
    if (!existingRow) {
      return state; // No-op if row not found
    }
    return {
      ...state,
      [fileId]: {
        ...existingBatch,
        rows: {
          ...existingBatch.rows,
          [rowId]: {
            ...existingRow,
            skipped: !existingRow.skipped
          }
        }
      }
    };
  }
  case BATCH_UPLOAD_EDIT_SET_LOADING: {
    const { fileId, loading } = action.payload;
    const existingBatch = state[fileId];
    if (!existingBatch) {
      return state;
    }
    return {
      ...state,
      [fileId]: {
        ...existingBatch,
        loading,
        // Reset progress when loading is done
        loadingProgress: loading ? (existingBatch.loadingProgress || { geocoding: 0, entityFields: 0, total: 0 }) : null
      }
    };
  }
  case BATCH_UPLOAD_EDIT_SET_LOADING_PROGRESS: {
    const { fileId, geocoding, entityFields, total } = action.payload;
    const existingBatch = state[fileId];
    if (!existingBatch) {
      return state;
    }
    return {
      ...state,
      [fileId]: {
        ...existingBatch,
        loadingProgress: {
          geocoding: geocoding ?? existingBatch.loadingProgress?.geocoding ?? 0,
          entityFields: entityFields ?? existingBatch.loadingProgress?.entityFields ?? 0,
          total: total ?? existingBatch.loadingProgress?.total ?? 0
        }
      }
    };
  }
  default:
    return state;
  }
};

export default batchEditReducer;
